import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class DiscussionUnbannedNotification extends Notification {
  icon() {
    return 'fas fa-user-check';
  }
  href() {
    const discussion = this.attrs.notification.subject();
    return discussion ? app.route.discussion(discussion) : '#';
  }
  content() {
    const notification = this.attrs.notification;
    const user = notification.fromUser();
    const discussion = notification.subject();
    return app.translator.trans('huseyinfiliz-discussion-ban.forum.notifications.discussion_unbanned_text', {
      username: user ? user.displayName() : app.translator.trans('core.lib.username.deleted_text'),
      title: discussion ? discussion.title() : ''
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('huseyinfiliz-discussion-ban', 'forum/components/DiscussionUnbannedNotification', DiscussionUnbannedNotification);